/**
 * 处理广告链接, 加上source_location参数，用于标识广告来源，主要用于会员购买弹窗
 * @param record 广告数据
 * @returns
 */
export function handleAdLink(record: IADData) {
  // 检查 record 和 material 是否存在
  if (!record?.material?.link) {
    return "";
  }

  const originalLink = record.material.link;

  // 检查是否为有效的字符串
  if (typeof originalLink !== "string" || originalLink.trim() === "") {
    return "";
  }

  try {
    // 检查是否包含 VIP 标识
    const isVipHashPath = originalLink.includes("#buyVip");

    if (isVipHashPath) {
      // 获取 hash 和 query 参数， query在前，hash在后
      const { path, query, hash } = parseUrl(originalLink);
      // 确保 position.name 存在
      const sourceName = record?.position?.name || "";
      const source =
        record.promotion.id +
        "_" +
        record?.material?.showcase_id +
        "_" +
        record?.material?.id;

      return `${path}?${query}&source=${source}&source_location=${encodeURIComponent(
        sourceName
      )}${hash}`;
    }
    return originalLink;
  } catch (error) {
    console.warn("处理链接时出错:", error);
    return originalLink;
  }
}

/**
 * 解析链接，获取path、query、hash
 * @example
 * parseUrl("https://example.com/path?query=param1#hash") // { path: "/path", query: "query=param1", hash: "#hash" }
 * parseUrl("https://example.com/path#hash") // { path: "/path", query: "", hash: "#hash" }
 * parseUrl("https://example.com/path?query=param1") // { path: "/path", query: "query=param1", hash: "" }
 * parseUrl("https://example.com/path") // { path: "/path", query: "", hash: "" }
 * @param url 链接
 * @returns
 */
function parseUrl(url: string) {
  // 移除开头和结尾的空白字符
  url = url.trim();

  let path = "";
  let query = "";
  let hash = "";

  // 先提取 hash 部分
  const hashIndex = url.indexOf("#");
  if (hashIndex !== -1) {
    hash = url.substring(hashIndex);
    url = url.substring(0, hashIndex);
  }

  // 提取 query 部分
  const queryIndex = url.indexOf("?");
  if (queryIndex !== -1) {
    query = url.substring(queryIndex + 1);
    url = url.substring(0, queryIndex);
  }

  // 剩余部分就是 path
  path = url;

  return {
    path: path,
    query: query,
    hash: hash,
  };
}
